import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  TextField,
  makeStyles,
  Grid,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { BudgetDialogProps } from '../../interfaces/types';

const useStyles = makeStyles(theme => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: theme.spacing(4),
  },
  dialogContent: {
    minWidth: '400px',
  },
  inputField: {
    marginTop: theme.spacing(2),
  },
  actionButton: {
    marginLeft: theme.spacing(1),
  },
}));

export const BudgetDialog: React.FC<BudgetDialogProps> = ({
  open,
  budgetInput,
  selectedCostCenter,
  onClose,
  onBudgetInputChange,
  onSave,
}) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant="h6">
          Set Budget for {selectedCostCenter?.name}
        </Typography>
        <IconButton
          className={classes.closeButton}
          onClick={onClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="body2" color="textSecondary">
          Enter the monthly budget amount in USD for this cost center.
        </Typography>
        <TextField
          fullWidth
          type="number"
          value={budgetInput}
          onChange={e => onBudgetInputChange(e.target.value)}
          placeholder="Enter budget amount"
          variant="outlined"
          size="small"
          className={classes.inputField}
          inputProps={{
            step: '0.01',
            min: '0',
          }}
        />
      </DialogContent>
      <DialogActions>
        <Grid>
          <Button
            className={classes.actionButton}
            onClick={onClose}
            color="default"
          >
            Cancel
          </Button>
          <Button
            className={classes.actionButton}
            onClick={onSave}
            color="primary"
            variant="contained"
          >
            Save Budget
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
